import { useQuery } from "@tanstack/react-query"
import { WORKSPACE_CAPABILITIES_KEY } from "../../../constants"
import { WorkspaceCapabilitiesResponse } from "../../../types"
import { useWorkspaceService } from "../services/useWorkspaceService"
import useWorkspace from "./useWorkspace"

type UseWorkspaceCapabilities = {
  capabilities: WorkspaceCapabilitiesResponse | null
  isLoading: boolean
  error: unknown
}

const useWorkspaceCapabilities = (): UseWorkspaceCapabilities => {
  const workspaceService = useWorkspaceService()
  const { workspace } = useWorkspace()

  const { data, isLoading, error } = useQuery({
    queryKey: [WORKSPACE_CAPABILITIES_KEY, workspace?.id],
    queryFn: async (): Promise<WorkspaceCapabilitiesResponse> => {
      return workspaceService.getWorkspaceCapabilities(String(workspace?.id))
    },
    enabled: Boolean(workspace?.id),
  })

  return {
    capabilities: data ?? null,
    isLoading,
    error,
  }
}

export default useWorkspaceCapabilities
